import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-gdo-introduction-video-dialog-component-webview',
    templateUrl: './gdo-introduction-video-dialog-component-webview.component.html',
    styleUrls: [
        './gdo-introduction-video-dialog-component-webview.component.scss',
    ],
    standalone: false
})
export class GdoIntroductionVideoDialogComponentWebviewComponent
  implements OnInit
{
  isAcura: boolean = false;
  constructor(
    private dialogRef: MatDialogRef<GdoIntroductionVideoDialogComponentWebviewComponent>,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.setIsAcuraLocally();
  }
  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }
  onClickClose() {
    this.dialogRef.close();
  }
  toggleVideo() {}
}
